import { connect } from 'react-redux';

import AccountView from '../components/AccountView';

const mapActionCreators = dispatch => ({});
const mapStateToProps = state => ({});

export default connect(
    mapStateToProps,
    mapActionCreators
)(AccountView);
